import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { BASE_URL } from "../../Constants";
import SocialIconRow from "../shared/SocialIconRow";
import SocialProfilesEditor from "../publicEmployees/SocialProfilesEditor";
import { setSocialLink } from "../publicEmployees/socialPlatforms";

// The company's social accounts, shown on all of its employee cards whichever card profile they
// use. A sub-company with none of its own shows its parent's. Saved separately from the card
// design because sub-companies can set these even though their card profiles are inherited.
const CompanySocialLinksSettings = ({ companyId, initialLinks, inheritedLinks, onSaved }) => {
  const { t } = useTranslation();
  const [links, setLinks] = useState(initialLinks || []);
  const [hasInvalidField, setHasInvalidField] = useState(false);
  const [saving, setSaving] = useState(false);

  const usingParentLinks = links.length === 0 && inheritedLinks?.length > 0;

  const handleChange = (platform, url) => {
    setLinks((prev) => setSocialLink({ socialLinks: prev }, platform, url).socialLinks);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const response = await axios.put(`${BASE_URL}/Company/${companyId}/social-links`, {
        socialLinks: links,
      });
      setLinks(response.data.socialLinks);
      onSaved(response.data.socialLinks);
      toast.success(t("settings.socialLinks.saved"));
    } catch (error) {
      toast.error(t("settings.socialLinks.saveFailed"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <section>
      <h2 className="text-lg font-semibold text-gray-900 mb-1">
        {t("settings.socialLinks.title")}
      </h2>
      {usingParentLinks && (
        <div className="mb-3 p-3 rounded-lg bg-gray-50 border border-gray-200">
          <p className="text-sm text-gray-700 mb-2">{t("settings.socialLinks.usingParent")}</p>
          <SocialIconRow links={inheritedLinks} interactive={false} color="#4b5563" className="!justify-start" />
        </div>
      )}
      <SocialProfilesEditor
        links={links}
        onChange={handleChange}
        hint={t("settings.socialLinks.hint")}
        onInvalidChange={setHasInvalidField}
      />
      <button
        type="button"
        onClick={handleSave}
        disabled={saving || hasInvalidField}
        className="w-fit mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 disabled:bg-gray-400"
      >
        {t("settings.socialLinks.save")}
      </button>
    </section>
  );
};

export default CompanySocialLinksSettings;
